module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/air-ballon-a475d7bac46273695be416903e7a1be7.svg";